import React from 'react';
import { Benefits } from '../components/home/Benefits';
import { Coach } from '../components/home/Coach';
import { Community } from '../components/home/Community';
import { Faq } from '../components/home/Faq';
import { FinalCta } from '../components/home/FinalCta';
import { FirstClass } from '../components/home/FirstClass';
import { Hero } from '../components/home/Hero';
import { JonJonesVideo } from '../components/home/JonJonesVideo';
import { ParentFeedback } from '../components/home/ParentFeedback';
import { Programs } from '../components/home/Programs';
import { TrustStrip } from '../components/home/TrustStrip';
import { Visit } from '../components/home/Visit';
import { Footer } from '../components/layout/Footer';
import { Header } from '../components/layout/Header';
export function Home() {
  return <div className="min-h-screen w-full bg-paper text-ink" data-id="element-380" data-mp="3kuii5g6dam7d">
      <Header data-id="element-381" data-mp="3owlus84rvwu8" />
      <main id="main" data-id="element-382" data-mp="3owccz7tvsvzm">
        <Hero data-id="element-383" data-mp="3ovki5z83z2ae" />
        <TrustStrip data-id="element-384" data-mp="3ov2ewin13nsz" />
        <JonJonesVideo data-id="element-385" data-mp="3oyqb5pjuyobe" />
        <Programs data-id="element-386" data-mp="30xb902pfuvw7" />
        <Benefits data-id="element-387" data-mp="30vqdoavav8xa" />
        <Coach data-id="element-388" data-mp="30w9lgyr8kgxl" />
        <ParentFeedback data-id="element-389" data-mp="30up285adgkf1" />
        <Community data-id="element-390" data-mp="2vxottnq1v5kr" />
        <FirstClass data-id="element-391" data-mp="2vx6ntzdl5czn" />
        <Visit data-id="element-392" data-mp="2vyzzxu6ywpf1" />
        <Faq data-id="element-393" data-mp="2vyhty5ui6wtx" />
        <FinalCta data-id="element-394" data-mp="2vvlta9r9tu1s" />
      </main>
      <Footer data-id="element-395" data-mp="2qyc14mchz4a9" />
    </div>;
}